//Code to convert double/multiple trailing slashes to single trailing slash in the URL
const url = window.location.pathname;
const regexp = new RegExp(/\/\/+/g);

if (regexp.test(url)) {
    let newUrl = url.replace(regexp, '/');
    newUrl = newUrl + window.location.search;
    window.history.replaceState({}, '', newUrl);
}